import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fp_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * FastAPI/Pydantic 422 responses use `detail: [{type, loc, msg, input, ctx}, ...]`
 * — an array of error OBJECTS.  When our 42-odd call sites pass that array
 * straight to `toast.error(err.response.data.detail)`, sonner tries to render
 * the objects as React children and the whole app crashes with:
 *     "Objects are not valid as a React child (found: object with keys
 *      {type, loc, msg, input, ctx})"
 *
 * Normalise validation errors into a readable string at the interceptor so
 * every existing call site keeps working.
 */
function normaliseValidationDetail(data) {
  if (!data || typeof data !== "object") return;
  const d = data.detail;
  if (!Array.isArray(d)) return;
  const parts = d
    .filter((e) => e && typeof e === "object")
    .map((e) => {
      const field = Array.isArray(e.loc)
        ? e.loc.filter((seg) => seg !== "body").join(".") || "input"
        : "input";
      return `${field}: ${e.msg || "invalid"}`;
    });
  if (parts.length) data.detail = parts.join(", ");
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 422) {
      normaliseValidationDetail(err.response.data);
    }
    if (err?.response?.status === 401) {
      localStorage.removeItem("fp_token");
      localStorage.removeItem("fp_user");
      if (!window.location.pathname.startsWith("/auth") && window.location.pathname !== "/") {
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
